import React, { useState, ChangeEvent } from 'react';
import { TextField } from '@cimpress/react-components';

interface SegmentsProps {
    segments: number;
    id: string;
    updateSegments: (data: { id: string; segments: number }) => void;
}

const isError = (value: number) => (!(Number.isFinite(value) && value >= 1 && value <= 100) ? 'error' : undefined);

const Segments: React.FC<SegmentsProps> = ({ segments, id, updateSegments }) => {
    const [validValue, setValidValue] = useState(segments);
    const [currentValue, setCurrentValue] = useState(segments);

    if (segments !== validValue) {
        setValidValue(segments);
        setCurrentValue(segments);
    }

    const status = isError(currentValue);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        const error = isError(value);
        setCurrentValue(value);
        if (!error) {
            updateSegments({ id, segments: value });
        }
    };

    return (
        <div className='segments'>
            <TextField
                className='segments__field'
                label='Segments'
                value={currentValue || (currentValue === 0 ? 0 : '')}
                status={status}
                onChange={onChange}
                type='number'
                onFocus={(e) => e.target.select()}
            />
        </div>
    );
};

export default React.memo(Segments);
